import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from "react";
export const defaultTexts = {
    close: "Schließen",
    loading: "Lädt",
    retry: "Erneut",
    unknownError: "Unbekannter Fehler",
    requestId: "Request-ID",
    notifications: "Benachrichtigungen",
    confidence: "Sicherheit",
    loadErrorTitle: "Neue Version verfügbar",
    loadErrorText: "Ein Teil der Anwendung ließ sich nicht laden, meist weil gerade eine neue Version eingespielt wurde oder die Anmeldung abgelaufen ist. Neu laden behebt das; deine Arbeit ist gespeichert.",
    renderErrorTitle: "Diese Ansicht konnte nicht angezeigt werden",
    renderErrorText: "Beim Anzeigen ist ein Fehler aufgetreten. Neu laden oder zur Startseite wechseln; Gespeichertes geht nicht verloren.",
    reload: "Neu laden",
    home: "Zur Startseite",
    technicalDetail: "Technische Angabe",
    ageNow: "gerade",
    ageMin: "min",
    ageHour: "h",
    ageDay: "T",
    cancel: "Abbrechen",
    rename: "Umbenennen",
    delete: "Löschen",
    renameFailed: "Umbenennen fehlgeschlagen",
    deleteFailed: "Löschen fehlgeschlagen",
    untitled: "Ohne Titel",
    confirmTitle: "Bitte bestätigen",
    confirmOk: "Bestätigen",
    assistantName: "KI-Assistent",
    assistantMark: "KI",
    assistantClose: "KI-Assistenten schließen (Esc)",
    assistantTyping: "KI-Assistent schreibt",
    assistantThinking: "Denkt nach…",
    assistantReasoning: "Gedankengang",
    assistantToolRunning: "Schaut nach:",
    assistantToolError: "Nicht möglich:",
    assistantToolDone: "Nachgesehen:",
    assistantCopy: "Kopieren",
    assistantCopied: "Kopiert",
    assistantCopyAnswer: "Antwort kopieren",
    assistantSend: "Senden",
    assistantSendTitle: "Senden (Enter)",
    assistantStop: "Antwort abbrechen",
    assistantMessageLabel: "Nachricht an den KI-Assistenten",
    assistantPlaceholder: "Frag den KI-Assistenten …",
    assistantAborted: "Abgebrochen",
    assistantStreamError: "Fehler im KI-Assistenten",
    assistantEmptyTitle: "Wobei kann ich helfen?",
    assistantEmptyText: "Vorschläge führst du selbst per Klick aus.",
    assistantContinue: "Weitermachen",
    assistantShowAll: "Alle Unterhaltungen anzeigen",
    assistantProposals: "Vorschläge zum Ausführen",
    assistantProposalRun: "Vorschlag des KI-Assistenten ausführen",
    assistantProposalFailed: "Ausführung fehlgeschlagen – erneut versuchen",
    assistantProposalDone: "ausgeführt",
    assistantConversations: "Unterhaltungen",
    assistantEarlier: "Frühere Unterhaltungen",
    assistantHistory: "Verlauf",
    assistantAllOnPage: "Alle auf eigener Seite",
    assistantNewConversation: "Neue Unterhaltung",
    assistantNew: "Neu",
    assistantSearch: "Unterhaltungen durchsuchen …",
    assistantNoConversations: "Noch keine Unterhaltungen",
    assistantNoMatch: "Keine passende Unterhaltung",
    assistantNewTitle: "Neuer Titel",
    assistantMessagesShort: "Nachr.",
    assistantContextSession: "Mit Kontext",
    assistantGeneralSession: "Allgemein",
    assistantWider: "Breiter",
    assistantNarrower: "Schmaler",
    assistantOpenPage: "Als Seite öffnen",
    assistantResize: "Breite des KI-Assistenten ändern (Pfeiltasten, Doppelklick: breit/schmal)",
    assistantResizeTitle: "Ziehen, um die Breite zu ändern · Doppelklick: breit/schmal",
    assistantKeySend: "senden",
    assistantKeyNewline: "neue Zeile",
    assistantKeyClose: "schließen",
    assistantToday: "Heute",
    assistantYesterday: "Gestern",
    assistantLast7: "Letzte 7 Tage",
    assistantOlder: "Älter",
    assistantAttach: "Bild hinzufügen",
    assistantCamera: "Foto aufnehmen",
    cameraTitle: "Foto aufnehmen",
    cameraPreview: "Kameravorschau",
    cameraStarting: "Kamera startet …",
    cameraLive: "Kamera bereit. Auslöser drücken, um das Foto aufzunehmen.",
    cameraShutter: "Foto aufnehmen",
    cameraTaken: "Foto aufgenommen",
    cameraRetake: "Neu aufnehmen",
    cameraUse: "Foto verwenden",
    cameraSwitch: "Kamera wechseln",
    cameraFallback: "Stattdessen eine Datei wählen",
    cameraDenied: "Der Kamerazugriff wurde verweigert. Erlauben Sie ihn in den Website-Einstellungen des Browsers, oder wählen Sie eine Datei.",
    cameraNone: "Keine Kamera gefunden. Wählen Sie stattdessen eine Datei.",
    cameraBusy: "Die Kamera wird von einer anderen App benutzt. Schließen Sie diese, oder wählen Sie eine Datei.",
    cameraFailed: "Die Kamera konnte nicht starten. Wählen Sie stattdessen eine Datei.",
    assistantRemoveAttachment: "Bild entfernen",
    assistantDropImages: "Bilder hier ablegen",
    assistantAttachmentType: "Dieses Bildformat wird nicht unterstützt",
    assistantAttachmentSize: "Das Bild ist zu groß",
    assistantAttachmentCount: "Höchstens {n} Bilder pro Nachricht",
    assistantAttachmentFailed: "Das Bild konnte nicht hochgeladen werden",
    assistantPreparing: "Bild wird vorbereitet …",
    assistantUploading: "Wird hochgeladen …",
    assistantImage: "Bild",
    assistantImageTitle: "Bild-Frage",
    assistantOpenImage: "Bild vergrößern",
    assistantSteps: "Arbeitsschritte ({n})",
    assistantStillWorking: "Arbeitet noch: {step}",
    assistantStillWorkingPlain: "Arbeitet noch …",
    assistantLookingAtImage: "Bild wird angesehen …",
    assistantUploadProgress: "Hochgeladen: {percent} %",
    back: "Zurück",
    next: "Weiter",
    done: "Fertig",
    skip: "Überspringen",
    no: "Nein",
    search: "Suchen",
    paletteLabel: "Befehlspalette",
    palettePlaceholder: "Suchen oder Befehl eingeben …",
    paletteResults: "Ergebnisse",
    paletteSelect: "wählen",
    paletteRun: "ausführen",
    shortcutsTitle: "Tastenkürzel",
    keyCtrl: "Strg",
    userMenu: "Benutzermenü",
    theme: "Darstellung",
    themeLight: "Hell",
    themeDark: "Dunkel",
    themeSystem: "System",
    themeLightTitle: "Immer hell",
    themeDarkTitle: "Immer dunkel",
    themeSystemTitle: "Wie im Betriebssystem eingestellt, wechselt mit ihm",
    logout: "Abmelden",
    tourClose: "Tour beenden",
    tourCloseTitle: "Tour beenden (Esc)",
    tourStepOf: "Schritt {n} von {total}",
    tourTryIt: "Probier’s aus:",
    tourLocked: "Während der Tour gesperrt",
    helpTitle: "Hilfe & Lernen",
    helpSubtitle: "Lernpfad, geführte Touren und das Handbuch zu jeder Funktion",
    helpPath: "Lernpfad",
    helpTours: "Touren",
    helpHandbook: "Handbuch",
    helpSearch: "Im Handbuch suchen",
    helpSearchPlaceholder: "Im Handbuch suchen …",
    helpIntro: "Einführung ansehen",
    helpReset: "Lernfortschritt zurücksetzen",
    helpResetConfirm: "Fortschritt wirklich zurücksetzen?",
    helpResetYes: "Ja, zurücksetzen",
    helpNoResults: "Nichts gefunden. Versuch ein anderes Wort.",
    pathTitle: "Dein Lernpfad",
    pathOf: "von {total}",
    pathMoodStart: "Jede Aufgabe dauert nur einen Moment. Die meisten erledigst du einfach beim Arbeiten.",
    pathMoodHalf: "Mehr als die Hälfte geschafft. Der Rest kommt beim Arbeiten fast von allein.",
    pathMoodGoing: "Guter Start. Weiter so, Aufgabe für Aufgabe.",
    pathMoodDone: "Alles gelernt. Du kennst jetzt jede Funktion.",
    taskDone: "erledigt",
    taskOpen: "offen",
    taskDoneAt: "Erledigt am {date}",
    toursIntro: "Eine Tour hebt Bereich für Bereich hervor und erklärt ihn direkt in der Anwendung. Während der Tour sind Knöpfe gesperrt, du kannst also nichts versehentlich auslösen. Mit [→] und [←] blätterst du, [Esc] beendet.",
    tourDoneBadge: "gemacht",
    tourMeta: "{minutes} Min. · {steps} Schritte",
    tourStart: "Starten",
    tourAgain: "Nochmal",
    articleTip: "Tipp:",
    articleTourText: "Lieber zeigen lassen? Die Tour führt dich durch diesen Bereich.",
    articleTourStart: "Tour starten",
    articleRelated: "Auch interessant",
    learnedTitle: "Gelernt: {title}",
    learnedProgress: "Lernpfad {done} von {total}",
    learnedAllTitle: "Lernpfad abgeschlossen",
    learnedAllText: "Du kennst jetzt jede Funktion.",
    welcomeLabel: "Einführung",
    welcomePages: "Seiten der Einführung",
    welcomePage: "Seite {n}",
    welcomeBrowse: "blättern",
    document: "Dokument",
    docPageShort: "S.",
    docPages: "Seiten",
    docPageLabel: "Seite {n}",
    docPageError: "Seite {n} konnte nicht geladen werden",
    zoomIn: "Vergrößern",
    zoomOut: "Verkleinern",
    zoomFit: "Auf Breite einpassen",
    docWider: "Dokument breit anzeigen",
    docNarrower: "Dokument wieder schmaler",
    docOpenOriginal: "Original öffnen",
    docClose: "Dokument schließen",
    docNoEvidence: "kein Beleg im Dokument",
    docApprox: "handschriftlich · ungefähre Stelle, S. {page} – bitte im Dokument vergleichen",
    docApproxShort: "handschriftlich",
    docApproxTitle: "{label} · handschriftlich, ungefähre Stelle",
    docMarkLabel: "Beleg für {label}",
    docOcr: "OCR",
    docOcrTitle: "Gescannte Seite – Text per OCR erkannt",
    docWorkingTitle: "Das Dokument wird gelesen …",
    docWorkingText: "Seitenbilder erscheinen, sobald die Extraktion fertig ist.",
    docNoPages: "Keine Seitenbilder",
    docNoPagesText: "Das Original kann über „Original öffnen“ angezeigt werden.",
    signingIn: "Anmeldung läuft",
    checkingAccess: "Anmeldung wird geprüft",
    noAccessTitle: "Noch kein Zugriff auf diese Anwendung",
    noAccessText: "Die Anmeldung hat geklappt, aber deinem Konto ist noch keine Rolle für diese Anwendung zugewiesen.",
    signedInAs: "Angemeldet als",
    email: "E-Mail",
    signedInVia: "über",
    howToAccess: "So bekommst du Zugriff",
    howToAccessText: "Die Rollen vergibt die IT. Frage dort eine dieser Rollen an:",
    copyRequest: "Anfrage kopieren",
    copied: "Kopiert",
    signInAgain: "Rolle erhalten? Neu anmelden",
    noAccessNote: "Rollen werden bei der Anmeldung übernommen. Nach der Zuweisung einmal neu anmelden; mit einem anderen Konto anmelden geht über „Abmelden“.",
    // Lumi
    lumiMoodIdle: "{assistant} ist da und hilft",
    lumiMoodListening: "{assistant} hört zu",
    lumiMoodWorking: "{assistant} arbeitet",
    lumiMoodSpeaking: "{assistant} antwortet",
    lumiMoodGuiding: "{assistant} führt Sie",
    lumiMoodGuidingStep: "{assistant} führt Sie: Schritt {n}, {title}",
    lumiMoodCareful: "Vorsicht: Bestätigen Sie zuerst den Sicherheitsschritt",
    lumiMoodSolved: "Gelöst",
    lumiSourceOpen: "{name} öffnen",
    lumiSources: "Quellen",
    lumiMoreSources: "Weitere Quellen",
    lumiWebSources: "Aus dem Web",
    lumiWhy: "Warum",
    lumiWorked: "Hat funktioniert",
    lumiNotWorked: "Hat nicht funktioniert",
    lumiSavedForTeam: "Für Ihr Team gespeichert",
    lumiOriginKB: "Aus Ihren Dokumenten",
    lumiOriginWeb: "Aus dem Web",
    lumiOriginMixed: "Aus Dokumenten und Web",
    lumiOriginGeneral: "Allgemeinwissen, nicht aus Ihren Dokumenten",
    lumiSolutionsFound: "{n} mögliche Lösungen",
    lumiGuideTitle: "Geführte Lösung",
    lumiGuideStepOf: "Schritt {n} von etwa {m}",
    lumiGuideOpen: "Geführte Lösung öffnen",
    lumiGuideSolved: "Gelöst",
    lumiGuideHandover: "Übergeben",
    lumiGuideNotSolved: "Nicht gelöst",
    lumiGuideDanger: "Gefahr",
    lumiGuideCaution: "Vorsicht",
    lumiGuideSafetyConfirm: "Gelesen, die Maschine ist sicher",
    lumiGuideSafetyConfirmed: "Sicherheit bestätigt",
    lumiGuideExpected: "Sie sollten sehen",
    lumiGuideFigure: "Abbildung",
    lumiGuideAnswers: "Ihre Antwort",
    lumiGuideHistory: "Schritte",
    lumiGuideStateDone: "erledigt",
    lumiGuideStateCurrent: "aktueller Schritt",
    lumiGuideStateUpcoming: "folgt",
    lumiGuideAdapts: "Die nächsten Schritte passen sich Ihren Antworten an.",
    lumiGuideViewSwitch: "Geführte Lösung oder Chat",
    lumiGuideTab: "Führung",
    lumiChatTab: "Chat",
    lumiHandoverTitle: "Übergabe",
    lumiHandoverIntro: "Die Lösung ist nicht abgeschlossen. Geben Sie das an einen Kollegen oder den Service weiter.",
    lumiHandoverSymptom: "Symptom",
    lumiHandoverSteps: "Versuchte Schritte und Ergebnisse",
    lumiHandoverPhotos: "{n} Fotos im Gespräch",
    lumiHandoverSources: "Handbuchseiten",
    lumiHandoverNotAnswered: "nicht beantwortet",
    lumiHandoverSummary: "Zusammenfassung",
    lumiHandoverCopy: "Kopieren",
    lumiHandoverShare: "Teilen",
    lumiHandoverCopied: "Zusammenfassung kopiert.",
    lumiHandoverCopyFailed: "Die Zusammenfassung konnte nicht kopiert werden.",
    lumiMachine: "Maschine",
    lumiNoMachine: "Keine Maschine angegeben",
    lumiFilterChoose: "Maschine wählen",
    lumiFilterChange: "Maschine ändern",
    lumiFilterFor: "Für {label}",
    lumiFilterRemove: "Maschinenfilter entfernen",
    lumiFieldSolution: "Feldlösung",
};
export const TextsContext = createContext(defaultTexts);
export function TextsProvider({ texts, children }) {
    const parent = useContext(TextsContext);
    const value = useMemo(() => ({ ...parent, ...texts }), [parent, texts]);
    return _jsx(TextsContext.Provider, { value: value, children: children });
}
export const useTexts = () => useContext(TextsContext);
/** Fills {name} placeholders of a text: fill("Schritt {n} von {total}", { n: 2, total: 5 }). */
export const fill = (text, vars) => text.replace(/\{(\w+)\}/g, (m, k) => (k in vars ? String(vars[k]) : m));
